import { render, staticRenderFns } from "./t-page.vue?vue&type=template&id=0771f7eb&"
import script from "./t-page.vue?vue&type=script&lang=js&"
export * from "./t-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports